module.exports = __webpack_public_path__ + "static/media/bg_1.2418aca0.jpg";